import ImageOne from '../../images/image1.jpg'
import ImageTwo from '../../images/image2.jpg'
import ImageThree from '../../images/image3.jpg'
import ImageFour from '../../images/image4.jpg'
import ImageFive from '../../images/image5.jpg'
import ImageSix from '../../images/image6.png'
import ImageSeven from '../../images/image7.jpg'
import ImageEight from '../../images/image8.jpg'
import ImageNine from '../../images/image9.jpg'
import ImageTen from '../../images/image10.jpg'
import ImageEleven from '../../images/image11.jpg'
import ImageTwelve from '../../images/image12.jpg'
import ImageThirteen from '../../images/image13.jpg'


export const SliderData = [
    {
        title: 'Wardens',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=fc0d6554-4aca-47e4-956f-337d2c7f5077',
        image: ImageOne,
        blank_stars: '☆☆☆☆☆',
        filled_stars: '★★★★★',
        ratings: 1331,
        stars: '150%',
        alt: 'Wardens'
    },
    {
        title: 'Shadows',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=fe666855-dfdc-4833-a02c-5ca2c51b40f7',
        image: ImageTwo,
        blank_stars: '☆☆☆☆☆',
        filled_stars: '★★★★★',
        ratings: 612,
        stars: '150%',
        alt: 'Shadows'
    },
    {
        title: 'More Sheeps',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=e9feeda0-2739-431b-836c-a573a841bd8a',
        image: ImageThree,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'More Sheeps'
    },
    {
        title: 'Trade Cubes',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=9cef7c10-270d-40f2-a483-8e9701b4b6c9',
        image: ImageFour,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Trade Cubes'
    },
    {
        title: 'Emo Squad',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=ddfc4a14-1c4e-4ee0-978a-0c4c694d6a9b',
        image: ImageFive,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Emo Squad'
    },
    {
        title: 'Anime Clan',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=0e9514ee-78e1-4844-b492-80559eac1d73',
        image: ImageSix,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Anime Clan'
    },
    {
        title: 'Swamp Land',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=351ee668-4cbf-4230-9e02-b8e6ce506670',
        image: ImageSeven,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Swamp Land'
    },
    {
        title: 'Sky Castle',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=9f0b22b0-7ccd-4321-abce-b968b41984a4',
        image: ImageEight,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Sky Castle'
    },
    {
        title: 'Backrooms Monsters',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=af00a4b7-69fb-4990-a738-e13b4d6d99c3',
        image: ImageNine,
        blank_stars: '☆☆☆☆☆',
        filled_stars: '★★★★★',
        ratings: 890,
        stars: '140%',
        alt: 'Backrooms Monsters'
    },
    {
        title: 'RGB Nekos',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=e8ca8422-531b-4c88-974c-fd031d9e56e0',
        image: ImageTen,
        blank_stars: '☆☆☆☆☆',
        filled_stars: '★★★★★',
        ratings: 652,
        stars: '150%',
        alt: 'RGB Nekos'
    },
    {
        title: 'Trade Cubes',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=9cef7c10-270d-40f2-a483-8e9701b4b6c9',
        image: ImageEleven,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Trade Cubes'
    },
    {
        title: 'Spooky Academia',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=5da1cf70-b5ad-4978-b314-f5b48ee8931b',
        image: ImageTwelve,
        blank_stars: '',
        filled_stars: '',
        ratings: '',
        stars: '',
        alt: 'Spooky Academia'
    },
    {
        title: 'Valentines Day',
        link: 'https://marketplace.minecraft.net/en-us/pdp?id=eeaf45a0-171a-417b-88ef-809ebbe1c011',
        image: ImageThirteen,
        blank_stars: '☆☆☆☆☆',
        filled_stars: '★★★★★',
        ratings: 345,
        stars: '147%',
        alt: 'Valentines Day'
    }
]